import html2pdf from 'html2pdf.js';

const toMarathiDigits = (input) => {
  const marathiDigits = ['०','१','२','३','४','५','६','७','८','९'];
  return input?.toString().replace(/\d/g, d => marathiDigits[d]) || '';
};

const formatDateMarathi = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return `${toMarathiDigits(d.getDate().toString().padStart(2, '0'))}/${toMarathiDigits((d.getMonth()+1).toString().padStart(2, '0'))}/${toMarathiDigits(d.getFullYear())}`;
};

const getTodayMarathiDate = () => {
  const d = new Date();
  return formatDateMarathi(d.toISOString());
};

const FinalAwardNotice = {
  downloadSingle: (landowner) => {
    const container = document.createElement('div');
    container.innerHTML = FinalAwardNotice.renderHTML(landowner);
    html2pdf().from(container).set({
      margin: 0,
      filename: `${landowner.owner_name}_FinalAwardNotice.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    }).save();
  },

  downloadAll: (landowners) => {
    const container = document.createElement('div');
    landowners.forEach((data) => {
      const div = document.createElement('div');
      div.innerHTML = FinalAwardNotice.renderHTML(data);
      div.style.pageBreakAfter = 'always';
      container.appendChild(div);
    });
    html2pdf().from(container).set({
      margin: 0,
      filename: `FinalAwardNotices.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    }).save();
  },

  renderHTML: (data) => {
    const {
      village_name, taluka_name, dist_name,
      survey_no, land_area, LandAcquisition_id,
      kjp_date, total_compensation
    } = data;

    const rewardDate = formatDateMarathi(kjp_date);
    const today = getTodayMarathiDate();

    const area = toMarathiDigits(land_area);
    const survey = survey_no;
    const village = village_name;
    const taluka = taluka_name;
    const dist = dist_name;
    const acqNo = toMarathiDigits(LandAcquisition_id);
    const compensation = `रु. ${toMarathiDigits(total_compensation || 0)}`;

    return `
      <div style="font-family: 'Noto Sans Devanagari', serif; font-size: 15px; padding: 50px; line-height: 1.8;">

        <!-- Page 1: Taaba Pavati -->
        <div>
          <div style="text-align: right;">निवाडा अ. क्र. __________</div>
          <h2 style="text-align: center; font-weight: bold; text-decoration: underline; margin-top: 20px;">ताबा पावती</h2>
          <p style="margin-top: 20px;">
            मी / आम्ही खाली सही करणारे खालील ताबा पावती लिहून देतो की, भूमिसंपादन प्रकरण क्र. ${acqNo} मध्ये ${village} (ता. ${taluka}, जि. ${dist}) येथील खालील नमूद मालमत्ता ${rewardDate} रोजी शासनाच्या मालकीस आली असून, सदरची मालमत्ता शासनाकडे ताब्यात दिली आहे.
          </p>
          <table border="1" style="width: 100%; text-align: center; margin-top: 20px; border-collapse: collapse;">
            <thead>
              <tr style="background-color: #f0f0f0;">
                <th style="padding: 8px;">गावाचे नाव</th>
                <th style="padding: 8px;">सर्व्हे  / गट क्र.</th>
                <th style="padding: 8px;">संपवलेले क्षेत्र (चौ.मी.)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="padding: 8px;">${village}</td>
                <td style="padding: 8px;">${survey}</td>
                <td style="padding: 8px;">${area}</td>
              </tr>
            </tbody>
          </table>

          <p style="margin-top: 40px;">ताबा देणाऱ्याची सही :- ____________________</p>
          <p>साक्षीदार : ____________________</p>
          <p style="text-align: right;">दिनांक : ${today}</p>

          <p style="margin-top: 50px;">उपविभागीय अधिकारी भू-संपादन (म. प्र.) ${dist}</p>
          <p style="text-align: right;">पान क्र. १</p>
        </div>

        <div style="page-break-after: always;"></div>

        <!-- Page 2: नमुना - क -->
        <div>
          <div style="text-align: right;">निवाडा अ. क्र. __________</div>
          <h2 style="text-align: center; font-weight: bold; text-decoration: underline; margin-top: 20px;">नमुना - क</h2>
          <p style="margin-top: 20px;">
            मी / आम्ही खाली सही करणारे नमुना 'क' लिहून देतो की, भूमिसंपादन प्रकरण क्र. ${acqNo} मध्ये ${village} (ता. ${taluka}, जि. ${dist}) येथील खालील नमूद मालमत्ता शासनाच्या मालकीस आली असून, सदरची मालमत्ता शासनाकडे ताब्यात दिली आहे.
          </p>
          <table border="1" style="width: 100%; text-align: center; margin-top: 25px; border-collapse: collapse;">
            <thead>
              <tr style="background-color: #f0f0f0;">
                <th style="padding: 8px;">गावाचे नाव</th>
                <th style="padding: 8px;">सर्व्हे  / गट क्र.</th>
                <th style="padding: 8px;">संपवलेले क्षेत्र (चौ.मी.)</th>
                <th style="padding: 8px;">भरपाई रक्कम</th>
                <th style="padding: 8px;">ताबा दिनांक</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="padding: 8px;">${village}</td>
                <td style="padding: 8px;">${survey}</td>
                <td style="padding: 8px;">${area}</td>
                <td style="padding: 8px;">${compensation}</td>
                <td style="padding: 8px;">${rewardDate}</td>
              </tr>
            </tbody>
          </table>

          <p style="margin-top: 40px;">ताबा देणाऱ्याची सही :- ____________________</p>
          <p>साक्षीदार : ____________________</p>
          <p style="text-align: right;">दिनांक : ${today}</p>

          <p style="margin-top: 50px;">उपविभागीय अधिकारी भू-संपादन (म. प्र.) ${dist}</p>
          <p style="text-align: right;">पान क्र. २</p>
        </div>

        <div style="page-break-after: always;"></div>

        <!-- Page 3: प्रमाणपत्र -->
        <div>
          <div style="text-align: right;">निवाडा अ. क्र. __________</div>
          <h2 style="text-align: center; font-weight: bold; text-decoration: underline; margin-top: 20px;">प्रमाणपत्र</h2>
          <p style="margin-top: 20px;">
            प्रमाणित करण्यात येते की, भूमिसंपादन प्रकरण क्र. ${acqNo} मध्ये ${village} (ता. ${taluka}, जि. ${dist}) येथील खाली नमूद मालमत्ता ${rewardDate} रोजी शासनाच्या मालकीस आली असून, त्याबाबत ताबा घेण्यात आला आहे.
          </p>
          <table border="1" style="width: 100%; text-align: center; margin-top: 25px; border-collapse: collapse;">
            <thead>
              <tr style="background-color: #f0f0f0;">
                <th style="padding: 8px;">गावाचे नाव</th>
                <th style="padding: 8px;">सर्व्हे  / गट क्र.</th>
                <th style="padding: 8px;">संपवलेले क्षेत्र (चौ.मी.)</th>
                <th style="padding: 8px;">भरपाई रक्कम</th>
                <th style="padding: 8px;">ताबा दिनांक</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="padding: 8px;">${village}</td>
                <td style="padding: 8px;">${survey}</td>
                <td style="padding: 8px;">${area}</td>
                <td style="padding: 8px;">${compensation}</td>
                <td style="padding: 8px;">${rewardDate}</td>
              </tr>
            </tbody>
          </table>

          <p style="margin-top: 60px;">उपविभागीय अधिकारी भू-संपादन</p>
          <p style="text-align: right;">दिनांक : ${today}</p>
          <p style="text-align: right;">पान क्र. ३</p>
        </div>
      </div>
    `;
  }
};

// export default FinalAwardNotice;
export const downloadAll = FinalAwardNotice.downloadAll;
export default FinalAwardNotice;
